import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { UserContext } from "../../context/UserContext";
import { AuthService } from "../../services/auth";
import { useAsync } from "../../utils/hooks/useAsync";
import Button from "../common/Button";

import "react-phone-input-2/lib/style.css";

import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";

type FormValidation = {
  email: boolean;
  password: boolean;
  name: boolean;
  lastName: boolean;
  phoneNumber: boolean;
  companyName: boolean;
};

const EditProfileForm = () => {
  const { isLoading, run } = useAsync();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [formValidation, setFormValidation] = useState<FormValidation>({
    email: true,
    password: true,
    name: true,
    lastName: true,
    phoneNumber: true,
    companyName: true,
  });
  const [modified, setModified] = useState<boolean>(false);
  const [modifiedUser, setModifiedUser] = useState<User>(user);

  useEffect(() => {
    validaForm([
      { testedValue: modifiedUser.name, keyName: "name" },
      { testedValue: modifiedUser.lastName ?? "", keyName: "lastName" },
    ]);
  }, [modifiedUser]);

  useEffect(() => {
    setModifiedUser(user);
  }, [user]);

  const validaForm = (arr: { testedValue: string; keyName: string }[]) => {
    let formValidationResult = { ...formValidation };
    arr.forEach((x) => {
      if (/^[a-zA-ZÀ-ÖØ-öø-ÿ\u00f1\u00d1\s]+$/g.test(x.testedValue)) {
        formValidationResult = { ...formValidationResult, [x.keyName]: true };
      } else {
        formValidationResult = { ...formValidationResult, [x.keyName]: false };
      }
    });
    setFormValidation(formValidationResult);
  };
  const handleSaveProfile = () => {
    run(
      AuthService.editProfileData(
        modifiedUser.email,
        modifiedUser.name,
        modifiedUser.phoneNumber,
        modifiedUser.lastName ?? "",
        modifiedUser.companyName ?? ""
      )
    )
      .then((data: any) => {
        console.log(data);
        toast.success("Usuario modificado correctamente");
        setTimeout(() => {}, 2000);
      })
      .catch((err) => {
        throw new Error(err);
      });
  };
  const handleChange = (e: any) => {
    setModified(true);
    setModifiedUser({
      ...modifiedUser,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };

  const handlePhoneNumber = (phone: string) => {
    setModified(true);
    setModifiedUser({ ...modifiedUser, phoneNumber: phone });
  };
  return (
    <>
      <section className="auth_form_container auth_form_edit_container">
        <form onSubmit={handleSaveProfile} className="auth_form_edit_form">
          <>
            <label htmlFor="name">Nombre</label>
            <input
              className={""}
              name="name"
              type="text"
              id="name"
              value={modifiedUser?.name}
              onChange={handleChange}
            />
            {!formValidation.name && (
              <p className="alert__message">Ingresá un nombre válido</p>
            )}
            <label htmlFor="lastName">Apellido</label>
            <input
              name="lastName"
              type="text"
              id="lastName"
              value={modifiedUser?.lastName}
              onChange={handleChange}
            />
            {!formValidation.lastName && (
              <p className="alert__message">Ingresá un apellido válido</p>
            )}
            <label htmlFor="companyName">Razón social / referencia</label>
            <input
              className={formValidation.companyName ? "" : "error__input"}
              name="companyName"
              type="text"
              id="companyName"
              value={modifiedUser?.companyName}
              onChange={handleChange}
            />
            {!formValidation.companyName && (
              <p className="alert__message">Ingresá una razón social válida</p>
            )}
            <label htmlFor="phoneNumber">Teléfono (WhatsApp)</label>

            <PhoneInput
              country={"ar"} // Establece el país inicial (en este caso, Estados Unidos)
              value={modifiedUser?.phoneNumber}
              inputClass="phoneNumberInput"
              buttonClass="phoneNumberSelect"
              regions={"south-america"}
              autoFormat={false}
              onChange={(phone) => handlePhoneNumber(phone)}
            />
            <p className="phoneNumberFormat">
              Completar usando código de país y área.
            </p>
            <p className="phoneNumberFormat">Ejemplo +54 911 5316 6748</p>
            {!formValidation.phoneNumber && (
              <p className="alert__message">Ingresá un teléfono válido</p>
            )}
          </>

          <label htmlFor="email">Email</label>
          <input
            className={formValidation.email ? "" : "error__input"}
            name="email"
            type="text"
            id="email"
            disabled={true}
            value={user?.email}
          />
          {!formValidation.email && (
            <p className="alert__message">
              Email inválido. Chequeá y volvé a intentar
            </p>
          )}

          <div className="auth_form__password-container">
            <label htmlFor="password">Contraseña*</label>
          </div>

          <input
            className={""}
            name="password"
            type={"password"}
            id="password"
            value={"******"}
            disabled={true}
          />
          <Button
            onClick={() => navigate("/forgot-password")}
            isLoading={isLoading}
            className="auth_form__button__white"
            type="submit"
          >
            {"Modificar mi contraseña"}
          </Button>
          {modified &&
            (!formValidation.name ||
            !formValidation.phoneNumber ||
            !formValidation.companyName ||
            !formValidation.lastName ? (
              <>
                <Button
                  isLoading={isLoading}
                  className="auth_form__button_disabled"
                  type="button"
                >
                  {"Guardar"}
                </Button>
                <p className="alert__message">
                  Verifique los datos ingresados.
                </p>
              </>
            ) : (
              <Button
                isLoading={isLoading}
                className="auth_form__button"
                type="button"
                onClick={handleSaveProfile}
              >
                {"Guardar"}
              </Button>
            ))}
        </form>
      </section>
    </>
  );
};

export default EditProfileForm;
